import { render, staticRenderFns } from "./view-request-duration.vue?vue&type=template&id=3e9ff877&"
import script from "./view-request-duration.vue?vue&type=script&lang=js&"
export * from "./view-request-duration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports